module.exports = __webpack_public_path__ + "img/symbol_7.86241055.png";